<template>
    <div class="import-file-create-or-edit">
        <b-sidebar
            id="sidebar-task-handler"
            data-test="sidebar"
            sidebar-class="sidebar-lg"
            :visible="isDataImportSideBarActive"
            bg-variant="white"
            shadow
            backdrop
            no-header
            right
            @change="
                (val) => $emit('update:is-data-import-sidebar-active', val)
            "
            @hidden="clearFormData"
        >
            <template #default="{ hide }">
                <!-- Header -->
                <div
                    class="
                        d-flex
                        justify-content-between
                        align-items-center
                        content-sidebar-header
                        px-2
                        py-1
                        side-bar-header
                    "
                >
                    <h3 class="mb-0">
                        {{ sideBarTitle }}
                    </h3>

                    <div>
                        <feather-icon
                            class="ml-1 cursor-pointer"
                            icon="XIcon"
                            size="16"
                            @click="hide"
                        />
                    </div>
                </div>

                <!-- Body -->
                <validation-observer
                    v-slot="{ handleSubmit }"
                    ref="refFormObserver"
                >
                    <!-- Form -->
                    <b-form
                        class="p-2"
                        @submit.prevent="handleSubmit(onSubmit)"
                        @reset.prevent="resetForm"
                    >
                        <!-- Title -->
                        <validation-provider
                            v-slot="{ errors }"
                            name="category"
                            rules="required"
                        >
                            <b-form-group label="Category" label-for="category">
                                <b-form-input
                                    id="category"
                                    v-model="importData.category"
                                    :state="errors.length > 0 ? false : null"
                                    :disabled="dataStatus==='upload'"
                                    trim
                                    placeholder="Enter category"
                                    data-test ="category"
                                />
                                   <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>

                        <validation-provider
                            v-slot="{ errors }"
                            name="regulations/legislation"
                            rules="required"
                        >
                            <b-form-group label="Regulations/Legislation" label-for="regulations-legislation">
                               <template>
                                    <b-form-tags
                                        ref="regulations"
                                        v-model="importData.regulations" 
                                        class="regulations"
                                        :placeholder="dataStatus!=='view' ? 'Enter regulations/legislation' : ''" 
                                        :disabled="dataStatus==='upload'"
                                    />
                                </template>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>

                        <!-- FILE UPLOAD -->
                        <div v-if="shouldShowFileUploader" class="fileUploader">
                            <template>
                                <validation-provider
                                    v-slot="{ errors }"
                                    name="import file"
                                    rules="required"
                                >
                                    <b-form-group
                                        :state="errors.length > 0 ? false : null"
                                    >
                                        <div class="agent">
                                            <VueFileAgent
                                                ref="fileUploader"
                                                v-model="files"
                                                :theme="'list'"
                                                :multiple="true"
                                                :deletable="true"
                                                :meta="true"
                                                :accept="'.xml'"
                                                class="vue-agent-custom"
                                                :max-size="'25MB'"
                                                :max-files="5"
                                                :help-text="'Choose xml files'"
                                                :error-text="{
                                                type: 'Invalid file type. Only xml Allowed',
                                                size: 'Files should not exceed 25MB in size',
                                                }"
                                                @select="filesSelected($event)"
                                            >
                                                <template #file-preview-new>
                                                    <div key="new" class="text-left my-1">
                                                        <b-form-group>
                                                            <div class="d-flex flex-flow-wrap align-items-center">
                                                                <b-button
                                                                    variant="outline-primary"
                                                                    class="attach-btn"
                                                                    data-test="import-btn"
                                                                    >Import Files
                                                                    <vector
                                                                        data-name="pin"
                                                                        data-width="15px"
                                                                        data-height="12px"
                                                                    />
                                                                </b-button>

                                                                <small
                                                                    class="d-block ml-1"
                                                                    style="font-size: 1em"
                                                                >
                                                                    Only XML are allowed.
                                                                </small>
                                                            </div>
                                                        </b-form-group>
                                                    </div>
                                                </template>

                                            
                                                <template #file-preview="slotProps">
                                                    <div
                                                        :key="slotProps.index"
                                                        class="grid-box-item file-row p-1"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="close remove"
                                                            aria-label="Remove"
                                                            @click="
                                                                removeFileRecord(
                                                                    slotProps.fileRecord
                                                                )
                                                            "
                                                        >
                                                            <vector
                                                                data-type="icon"
                                                                data-name="cancel"
                                                            ></vector>
                                                        </button>

                                                        <strong>{{
                                                            slotProps.fileRecord.name()
                                                        }}</strong>
                                                        <span class="text-muted"
                                                            > ({{
                                                                slotProps.fileRecord.size()
                                                            }})</span
                                                        >
                                                    </div>
                                                </template>
                                            </VueFileAgent>
                                            <small class="text-danger" style="position:relative; bottom:10px">{{ errors[0] }}</small>
                                        </div>
                                    </b-form-group>
                                </validation-provider>
                            </template>
                        </div>

                         <validation-provider
                            v-slot="{ errors }"
                            name="last updated"
                            rules="required"
                            >
                                <b-form-group label="Last updated" :state="errors.length > 0 ? false : null">
                                    <flat-pickr
                                        v-model="importData.lastUpdated"
                                        placeholder="Pick a date"
                                        class="form-control"
                                        :config="datePickerConfig"
                                        data-test="last-updated"
                                    />
                                <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                        </validation-provider>

                        <!-- Form Actions -->
                        <div class="d-flex">
                            <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                :disabled="isButtonActionLoading"
                                variant="primary"
                                class="
                                    mr-1
                                    mt-1
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                                type="submit"
                                data-test="create-import-file-btn"
                                >
                                <span :class="isButtonActionLoading ? 'mr-1' : ''">
                                    {{ dataStatus === 'edit' ? "Update" : "Add " }}
                                </span>

                                <img
                                    v-if="(dataStatus === 'create' || dataStatus === 'upload') && !isButtonActionLoading"
                                    :src="'/illustrations/add-circle.svg'"
                                    class="ml-1"
                                    alt="add-logo"
                                />

                                <img
                                    v-if="dataStatus === 'edit' && !isButtonActionLoading"
                                    :src="'/illustrations/edit.svg'"
                                    class="ml-1"
                                    alt="edit-logo"
                                />
                                <normal-loader v-if="isButtonActionLoading" class="action-button left-10%" />
                            </b-button>

                            <b-button
                                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                class="
                                mt-1 
                                d-flex
                                justify-content-center
                                align-items-center"
                                variant="outline-primary"
                                data-test="cancel"
                                @click="$emit('update:is-data-import-sidebar-active', false)"
                                >
                                Cancel
                                <vector 
                                    data-type="icons" 
                                    data-width="15px" 
                                    data-height="15px" 
                                    data-name="cancel" 
                                    class="float-right ml-1"
                                    alt="cancel-logo"
                                />
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTags,
    BButton,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import { toRefs, ref, watch } from "@vue/composition-api";
import { errorToast } from "@/views/helpers/toast";
import { FILE } from '@/constants/config';

export default {
    components: {
        BForm,
        BButton,
        BSidebar,
        BFormGroup,
        BFormTags,
        flatPickr,
        BFormInput,

        ValidationProvider,
        ValidationObserver,
    },

    directives: {
        Ripple,
    },

    model: {
        prop: "isDataImportSideBarActive",
        event: "update:is-data-import-sidebar-active",
    },
    props: {
        isDataImportSideBarActive: {
            type: Boolean,
            required: true,
        },

        isButtonActionLoading: {
            type: Boolean,
            default: false,
        },

        dataImport: {
            type: Object,
            required: true,
        },
        
        dataStatus: { 
            type: String,
            default: "view"
        },
    },

    setup(props, { emit }) {
        const files = ref([]);
        // eslint-disable-next-line no-shadow
        function useImport(props, emit) {
            const importData = ref(JSON.parse(JSON.stringify(props.dataImport.value)));

            const resetDataImport = () => {
                // eslint-disable-next-line no-use-before-define
                clearForm();
                importData.value = JSON.parse(JSON.stringify(props.dataImport.value));
            };

            watch(props.dataImport, () => {
                resetDataImport();
            });
           
            const onSubmit = () => {
                const dataImport = JSON.parse(JSON.stringify(importData));

                dataImport.value.files = files.value;

                if (props.dataImport.value.id && props.dataStatus.value === 'edit') emit('update', dataImport.value);
                else if(props.dataImport.value.id && props.dataStatus.value === 'upload') emit('reUpload', dataImport.value);
                else emit('add', dataImport.value);
            };

            return {
                importData, 

                // UI
                onSubmit,
                resetDataImport,
            };
        };
         
        const {
            importData,

            // UI
            onSubmit, 
            resetDataImport
        } = useImport(toRefs(props), emit);

        const { refFormObserver, getValidationState, resetForm, clearForm } = formValidation(importData);

        function clearFormData() {
            resetDataImport();
            clearForm();
        };

        return {
            // Add New
            onSubmit,
            importData,

            // Form Validation
            resetForm,
            clearForm,
            refFormObserver,
            getValidationState, 
            
            // Methods
            clearFormData,

            // upload file
            files,
        };
    },

    data() {
        return {
            required,
            email,

            datePickerConfig: {
                altFormat: "j M Y",
                dateFormat: "j M Y",
                disableMobile: "true"
            },
        };
    },

    computed: {
        shouldShowFileUploader() {
            if(this.dataStatus === 'create' || this.dataStatus === 'upload')
                return true;
            return false;
        },

        sideBarTitle() {
            if(this.dataStatus === "create")
                return "Import";
            if(this.dataStatus === "edit")
                return "Update Import Details";
            if(this.dataStatus === "upload")
                return "Reupload Import Files";
            return "Import Details";
        },
    },

    methods: {
        removeFileRecord(fileRecord) {
            return this.$refs.fileUploader.deleteFileRecord(fileRecord);
        },

        filesSelected (fileRecordsNewlySelected) {
            const errorFileRecords = fileRecordsNewlySelected.filter(fileRecord => fileRecord.error);

            if (errorFileRecords.length >= 1)
            {
                errorFileRecords.forEach(file => {
                    if (file.error.type)
                    {
                        errorToast(`File extension: ${file.ext} is not valid and will be ignored.`);
                        this.filesArray = this.filesArray.filter(existingFile => existingFile.ext !== file.ext);
                    }

                    if (file.error.size)
                    {
                        errorToast(`One of your files has ${file.sizeText} which exceeds our limit: ${FILE.UPLOAD_LIMIT} and will be ignored.`);
                        this.filesArray = this.filesArray.filter(existingFile => existingFile.ext !== file.ext);
                    }
                });
            }
        }
    },
};
</script>

<style scope>
.side-bar-header{
   background: #f6f6f6 !important;
 }

.b-from-tags-field input::placeholder {
  color:  #6e6b7b !important;
}

.btn.b-form-tags-button {
    display: none;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>